import { cancelar, findCashbackPorCliente, findItensCashback } from "@/api/cashback";
import { CashbackServiceAdapter } from "@/usecases/cliente/adapter/CashbackServiceAdapter";
import { AxiosRequestConfig } from "axios";
import { injectable } from "inversify-props";

@injectable()
export class CashbackService implements CashbackServiceAdapter {
	findCashBackPorCliente = async (params?: any, config?: AxiosRequestConfig) => await findCashbackPorCliente(params, config)
	findItensCashback = async (params?: any, config?: AxiosRequestConfig) => await findItensCashback(params, config)
	cancelar = async (id: string) => await cancelar(id)
}